import React,{useState} from 'react';
import * as ReactDOM from 'react-dom';
import { getmessage,reducearray,arrprtojson } from './Dynamictable';
import { imgb64,chekf } from './utility';
import axios from 'axios';
import Configdata from './Defaultdata';
import { aroffers,getcolmvalbykypr } from './userdefaultdata';
import {txtnullchk} from './validation';
import PropTypes from 'prop-types';
import { debug } from 'util';
import Usersession from './Usersession';
import './home.css';

export const searchpost=(srchargs: any)=>{
const arrpro = [{
code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:""
}];
//const cntid = srchargs["contryid"];
//alert(srchargs);
//let proarrdata = arrprtojson(srchargs);
//alert(proarrdata.length);
let strimg = "";
let selectedpros = [{
code:"", userid:"", typeid:"", transtype:"", isowner:"", cityid:"", localityid:"", title:"", description:"", conditions:"", area:"", totalfloors:"",floorno:"", propertyage:"", postedby:"", ownership:"", aiminities:"", curtntstatus:"", phone:"", price:"", availablefrom:"",
 delflag:"", procontryid:"", aiminityvalues:"",age:""
}];
function getdata(){
	 try {
	// alert('in func ');

	const searchopts = Usersession.getSearchopts();
	const ptype = Usersession.getType();
        const localityd = searchopts.localid;
        const transctpid = searchopts.trnstpid;
	const cityid = Usersession.getCityId();
	//alert('in before tp ');

	//alert(ptype);
        let service = "/gethomeposts?prd=1&ctd="+cityid+"&ltd="+localityd+"&tpd="+transctpid;
        if(ptype == "2")
	 service ="/getlandposts?prd=1&ctd="+cityid+"&ltd="+localityd+"&tpd="+transctpid;
	alert(service);	
	axios.get(Configdata.srvurl + service)
            .then((response: any) => {
               
		const tdata = response.data;
		const proarrdata = arrprtojson(tdata);
		alert(tdata);
		//selectedpros = proarrdata;
		//setPros(proarrdata);
		//this.setState({selectedpros: proarrdata});
		
            })
            .catch((err: any) => {
                getmessage('Something went wrong','');
                
            });

                
          }
        catch (e) {
            debugger;

        }

	
      	//e.preventDefault()


     }	

    getdata();

return(
	<div id="searchmain">
	<div className="searchcointer" style={{maxHeight:'94vh',overflowY:'scroll',overflowX:'hidden'}}>
	<ul className="ulnobullet" style={{padding:'0px'}}>
          {arrpro.map((property)=>(
	   <li>
 	    <div className="searchdivrow">
		<div className="searchouterdiv">
		   <div style={{width:'100%',height:'28%'}}>
		      <div className="per100">
			<div className="searchphotodiv">
			  <div style={{width:'100%',height:'150px'}}>
			  <img src="" className="searchitemphoto"/>
			  </div>
			 <div style={{width:'100%',height:'20px'}}>
				<a href="#" >View Contact</a>
			</div>
		 	 </div>
			
			<div className="searchpiddiv">
			  <ul className="ulnobullet">
					  <li> PID:{property.code}</li>
				          <li> Kengere bengaluru </li>	
					  <li>9876545649</li>	 	
					</ul>

		 	 </div>

			</div>
		     </div>

		   <div style={{width:'100%',height:'45%'}}>
		<div className="per100">
		 	
		


		 	<div className="searchcontaintdiv">
   			 <table className="per100">
			     <tr>
				<td>
				   <div>
					<ul className="ulnobullet">
					  <li> Price</li>
				          <li> {property.price}L </li>		
					</ul>
				   </div>
				</td>
				<td>
				   <div>
					<ul className="ulnobullet">
					  <li> Area</li>
				          <li> {property.area} sft </li>		
					</ul>
				   </div>

				</td>

			     </tr>

			     <tr>
				<td>
				  <div>
				     <ul className="ulnobullet">
					  <li> Availablility</li>
				          <li> {property.availablefrom}</li>		
				    </ul>
				 </div>
				</td>
				<td>
				   <div>
				     <ul  className="ulnobullet">
					  <li> Posted By</li>
				          <li> {property.postedby}</li>		
				    </ul>
				 </div>

				</td>

			     </tr>




			      <tr>
				<td>
				     <div>
				     <ul className="ulnobullet">
					  <li> Condition</li>
				          <li> {property.conditions}</li>		
				    </ul>
				 </div>
				</td>
				<td>
				    <div>
				     <ul className="ulnobullet">
					  <li> Property Age</li>
				          <li> {property.propertyage}</li>		
				    </ul>
				 </div>
				</td>

			     </tr>

			     <tr>
				<td>
				     <div>
				     <ul className="ulnobullet">
					  <li> Floors</li>
				          <li> {property.totalfloors} / {property.floorno}</li>		
				    </ul>
				 </div>
				</td>
				<td>
				    <div>
				     <ul className="ulnobullet">
					  <li> Ownership</li>
				          <li> {property.ownership}</li>		
				    </ul>
				 </div>
				</td>

			     </tr>



			  </table>

	  		</div>
		 </div>
		</div>

	 <div style={{width:'100%',height:'34%'}}>
		<div className="per100">	
			<div style={{width:'100%',height:'20px',paddingLeft:'10px',float:'left'}}>	
			  Description:
			</div>
			<div className="descriptioncontain">	
			 
				{property.description}

			</div>

		</div>
	     </div>	
	    
	       </div>
	     </div>

	    </li>
	
       	   ))}
	</ul>
	</div>
	</div>

);
}

export const getimage = (str64: any)=>{
return(

<img src={str64} style={{width:'100%',height:'70vh'}} />

);
	
}
